import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/lib/services/common.service';
import { UserService } from 'src/app/lib/services/user.service';

@Component({
  selector: 'app-select-upi-app',
  templateUrl: './select-upi-app.component.html',
  styleUrls: ['./select-upi-app.component.scss'],
  standalone: false
})

export class SelectUpiAppComponent implements OnInit {
  upiapps = [
    {
      id: 1,
      app: 'Phone Pay',
      upi: '@ybl',
      image: 'assets/banking/Phone Pay.png',
      name: 'Rajesh Bishnoi',
      mobile: '3213211233',
      qrImage: ''
    },
    {
      id: 2,
      app: 'Paytm',
      upi: '@paytm',
      image: 'assets/banking/Paytm.png',
      name: 'Rajesh Bishnoi',
      mobile: '3213211233',
      qrImage: ''
    },
    {
      id: 3,
      app: 'BHIM',
      upi: '@bhim',
      image: 'assets/banking/BHIM.png',
      name: 'Rajesh Bishnoi',
      mobile: '3213211233',
      qrImage: ''
    },
    {
      id: 4,
      app: 'G pay',
      upi: '@okaxis',
      image: 'assets/banking/G pay.png',
      name: 'Rajesh Bishnoi',
      mobile: '3213211233',
      qrImage: ''
    },
    {
      id: 5,
      app: 'Uber',
      upi: '@uber',
      image: 'assets/banking/Uber.png',
      name: 'Rajesh Bishnoi',
      mobile: '3213211233',
      qrImage: ''
    },
    {
      id: 6,
      app: 'Axis pay',
      upi: '@axis',
      image: 'assets/banking/Axis pay.png',
      name: 'Rajesh Bishnoi',
      mobile: '3213211233',
      qrImage: ''
    },
    {
      id: 7,
      app: 'Mobikwik',
      upi: '@mobiquick',
      image: 'assets/banking/Mobikwik.png',
      name: 'Rajesh Bishnoi',
      mobile: '3213211233',
      qrImage: ''
    },
    {
      id: 8,
      app: 'SBI pay',
      upi: '@sbi',
      image: 'assets/banking/SBI pay.png',
      name: 'Rajesh Bishnoi',
      mobile: '3213211233',
      qrImage: ''
    }
  ];
  url: any;
  modifiedUrl: any;
  userId: any;
  userPaymentInfo: any;
  upiFormData: any;
  uploadUpiData: any;
  qrCodeURL: string;
  qr_image: string;
  upiInfo: any = [];
  form = {
    retailerData: {
      payment: {

      }
    }
  };

  upiAppName: any;


  constructor(
    private router: Router,
    public formBuilder: UntypedFormBuilder,
    public commonService: CommonService,
    private userService: UserService,
  ) { }

  ngOnInit() { }
  ionViewWillEnter() {
    this.getUserData();
  }
  // Get user's existing details
  getUserData() {
    this.userId =
      this.commonService.getUserData() && this.commonService.getUserData().userId;

    this.commonService.presentProgressBarLoading();
    this.userService.getUPI(this.userId ? this.userId : null).subscribe((userDetails: any) => {
      this.commonService.closeProgressBarLoading()
      this.userPaymentInfo = userDetails.data;
    }, err => {
      this.commonService.closeProgressBarLoading()
      console.log(err);
    });
  }

  imageData(data) {
    // console.log(data, "<<<<<<<image");
  }

  selectUpi(selectedUpi: any) {
    let values = this.upiapps.filter(app => app.id === selectedUpi);
    this.upiAppName = values;
    for (let i = 0; i < values.length; i++) {
      this.uploadUpiData = { upi: values[i].upi, app: values[i].app, name: values[i].name, mobile: values[i].mobile, qr_image: values[i].qrImage, active: true }
    }
    this.onFileChange(event);
    // this.presentActionSheet();
  }

  async onFileChange(event: any) {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
      reader.readAsDataURL(selectedFile);
      reader.onload = () => {
        this.url = reader.result as string;
        const prefix = 'https://s3.ap-south-1.amazonaws.com/dev.sarvm.com';
        const suffix = '/documents/ums/qr_code_image/';
        const fileName = selectedFile.name;
        const modifiedUrl = `${prefix}${suffix}${fileName}`;
      };
      const isLoading = await this.commonService.presentLoader();
      isLoading.present();
      this.userService.getQrCodeImageUploadUrl().subscribe((res: any) => {
        if (res.data.uploadURL) {
          if (this.url) {
            this.qrCodeURL = this.url;
            isLoading.dismiss();
            this.userService.uploadqr(this.modifiedUrl, res.data.uploadURL).subscribe((data) => {
              this.upiFormData = {
                name: this.uploadUpiData.name ? this.uploadUpiData.name : 'sarvm',
                mobile: this.uploadUpiData.mobile,
                app: this.uploadUpiData?.app,
                upi: this.uploadUpiData.mobile.concat(this.upiAppName[0]?.upi),
                qr_image: res.data.url,
                active: true
              }
            }, (err) => {
              this.commonService.danger(JSON.stringify(err));
            });
          }
        }
        isLoading.dismiss();
      }, err => {
        isLoading.dismiss();
      });
    }
  }

  async createUserUpi(userId: any, formData: any) {
    const isLoading = await this.commonService.presentLoader();
    isLoading.present();
    this.userService.createUPI(userId, formData).subscribe((res: any) => {
      if (res.success) {
        isLoading.dismiss();
        this.commonService.success('User UPI Created !!');
        this.router.navigateByUrl('/scan-qr-code');
      } else if (res && res.error) {
        this.commonService.danger(res.error.message);
      }
    }, err => {
      isLoading.dismiss();
      this.commonService.errorToast(err);
    })
  }
}
